/* =====================================================
   Florss PDP — JavaScript
   Sticky ATC · Calculadora frete · Parcelamento dinâmico
   Sem dependências externas. Vanilla.
   ===================================================== */
(function () {
  'use strict';

  // ────────────────────────────────────────────────────
  // 1. Sticky Add-to-Cart Bar
  //    Aparece após scroll de 600px, esconde sobre o footer
  // ────────────────────────────────────────────────────
  function initStickyATC() {
    var bars = Array.prototype.slice.call(document.querySelectorAll('[data-florss-sticky-atc]'));
    var bar = document.querySelector('[data-florss-sticky-atc-layout]') || bars[0];
    var trigger = document.querySelector('[data-florss-hero]');
    var footer = document.querySelector('footer, [data-florss-footer]');
    if (!bar || !trigger) return;

    document.body.classList.add('florss-sticky-atc-layout-active');

    function disableLegacyStickyBuy() {
      document.querySelectorAll('[data-florss-sticky-buy], .florss-sticky-buy').forEach(function (legacy) {
        legacy.classList.remove('is-visible');
        legacy.setAttribute('hidden', 'hidden');
        legacy.style.display = 'none';
      });
    }

    function keepOnlyLayoutBar() {
      bars = Array.prototype.slice.call(document.querySelectorAll('[data-florss-sticky-atc]'));
      var layoutBar = document.querySelector('[data-florss-sticky-atc-layout]');
      if (layoutBar) bar = layoutBar;

      bars.forEach(function (candidate) {
        if (candidate !== bar) candidate.remove();
      });

      if (bar.parentNode !== document.body) {
        document.body.appendChild(bar);
      }

      disableLegacyStickyBuy();
    }

    disableLegacyStickyBuy();
    keepOnlyLayoutBar();
    window.setTimeout(keepOnlyLayoutBar, 250);
    window.setTimeout(keepOnlyLayoutBar, 1000);

    var stickyButton = bar.querySelector('[data-florss-sticky-atc-button]');
    var productForm = document.querySelector('.florss-buybox__form');
    var submitButton = productForm ? productForm.querySelector('[data-florss-add-to-cart-submit], button[type="submit"]:not([name="return_to"])') : null;

    if (stickyButton && submitButton) {
      stickyButton.addEventListener('click', function () {
        if (stickyButton.disabled || submitButton.disabled) return;
        submitButton.click();
      });
    }

    var heroRect, footerRect, formRect;

    function update() {
      heroRect = trigger.getBoundingClientRect();
      formRect = productForm ? productForm.getBoundingClientRect() : null;
      var viewportH = window.innerHeight;

      var passedBuyBox = formRect ? formRect.bottom < 84 : false;
      var shouldShow = window.scrollY > 420 || passedBuyBox || heroRect.top < -260;

      // Esconde se o footer está visível
      if (footer) {
        footerRect = footer.getBoundingClientRect();
        if (footerRect.top < viewportH - 8) shouldShow = false;
      }

      bar.classList.toggle('is-visible', shouldShow);
      document.body.classList.toggle('florss-sticky-atc-visible', shouldShow);
    }

    var ticking = false;
    function onScroll() {
      if (!ticking) {
        window.requestAnimationFrame(function () {
          update();
          ticking = false;
        });
        ticking = true;
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    update();
  }

  // ────────────────────────────────────────────────────
  // 2. Quantidade — stepper -/+
  // ────────────────────────────────────────────────────
  function initQuantityStepper() {
    document.querySelectorAll('[data-florss-qty]').forEach(function (wrap) {
      var input = wrap.querySelector('input');
      var dec = wrap.querySelector('[data-florss-qty-dec]');
      var inc = wrap.querySelector('[data-florss-qty-inc]');
      if (!input || !dec || !inc) return;

      dec.addEventListener('click', function () {
        var v = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
        input.value = v;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
      inc.addEventListener('click', function () {
        var v = (parseInt(input.value, 10) || 1) + 1;
        input.value = v;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  }

  // ────────────────────────────────────────────────────
  // 3. Variantes — botões em pílula (não dropdown)
  //    Sincroniza com o input hidden de variant_id
  // ────────────────────────────────────────────────────
  function initVariantPicker() {
    var variantImageCache = null;

    function hideVariantButtonPrices() {
      document.querySelectorAll('.florss-variant-btn .variant-price').forEach(function (price) {
        price.hidden = true;
        price.style.display = 'none';
      });
    }

    function getProductHandle() {
      var hero = document.querySelector('[data-florss-hero]');
      if (hero && hero.dataset.productHandle) return hero.dataset.productHandle;
      var match = window.location.pathname.match(/\/products\/([^/?#]+)/);
      return match ? match[1] : '';
    }

    function loadVariantImages() {
      if (variantImageCache) return Promise.resolve(variantImageCache);

      var handle = getProductHandle();
      if (!handle) return Promise.resolve({});

      return fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
        .then(function (response) {
          if (!response.ok) throw new Error('Product JSON unavailable');
          return response.json();
        })
        .then(function (product) {
          var map = {};
          (product.variants || []).forEach(function (variant) {
            var src = variant.featured_image && variant.featured_image.src;
            if (src) {
              map[String(variant.id)] = {
                src: src,
                alt: variant.public_title || variant.title || product.title || ''
              };
            }
          });
          variantImageCache = map;
          return map;
        })
        .catch(function () {
          variantImageCache = {};
          return variantImageCache;
        });
    }

    function setVariantImage(src, alt) {
      if (!src) return;

      var mainImage = document.querySelector('[data-florss-main-image]');
      var stickyThumb = document.querySelector('.florss-sticky-atc .sticky-thumb');

      if (mainImage) {
        mainImage.removeAttribute('srcset');
        mainImage.removeAttribute('sizes');
        mainImage.src = src;
        mainImage.alt = alt || mainImage.alt || '';
      }

      if (stickyThumb && stickyThumb.tagName === 'IMG') {
        stickyThumb.removeAttribute('srcset');
        stickyThumb.removeAttribute('sizes');
        stickyThumb.src = src;
        stickyThumb.alt = alt || stickyThumb.alt || '';
      }

      document.querySelectorAll('[data-florss-thumb]').forEach(function (thumb) {
        var thumbSrc = thumb.dataset.florssSrc || '';
        thumb.classList.toggle('is-active', thumbSrc === src);
      });
    }

    hideVariantButtonPrices();

    document.querySelectorAll('[data-florss-variants]').forEach(function (group) {
      var buttons = group.querySelectorAll('[data-florss-variant]');
      var hidden = group.querySelector('[data-florss-variant-id]');
      var priceEl = document.querySelector('[data-florss-price]');
      var comparePriceEl = document.querySelector('[data-florss-compare-price]');
      var installmentEl = document.querySelector('[data-florss-installment]');

      buttons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          buttons.forEach(function (b) { b.classList.remove('is-active'); });
          btn.classList.add('is-active');

          if (hidden) hidden.value = btn.dataset.florssVariant;

          document.querySelectorAll('[data-florss-form-variant-id]').forEach(function (input) {
            input.value = btn.dataset.florssVariant;
          });

          // Atualiza preço se botão tiver atributos
          var price = btn.dataset.florssPrice;
          var compare = btn.dataset.florssCompare;
          var savingEl = document.querySelector('.florss-buybox__price .florss-badge--sage');
          if (price && priceEl) priceEl.textContent = price;
          if (comparePriceEl) {
            if (compare) {
              comparePriceEl.textContent = compare;
              comparePriceEl.style.display = '';
            } else {
              comparePriceEl.textContent = '';
              comparePriceEl.style.display = 'none';
            }
          }

          if (savingEl) {
            if (price && compare) {
              var saving = parsePrice(compare) - parsePrice(price);
              if (saving > 0) {
                savingEl.textContent = 'Economize R$ ' + formatBRL(saving);
                savingEl.style.display = 'inline-flex';
              } else {
                savingEl.textContent = '';
                savingEl.style.display = 'none';
              }
            } else {
              savingEl.textContent = '';
              savingEl.style.display = 'none';
            }
          }

          hideVariantButtonPrices();

          var variantImage = btn.dataset.florssImage;
          if (variantImage) {
            var variantAlt = btn.dataset.florssImageAlt || btn.textContent.trim();
            setVariantImage(variantImage, variantAlt);
          } else {
            loadVariantImages().then(function (imagesByVariant) {
              var image = imagesByVariant[String(btn.dataset.florssVariant)];
              if (image) setVariantImage(image.src, image.alt);
            });
          }

          // Recalcula parcelamento
          if (price && installmentEl) {
            updateInstallments(price, installmentEl);
          }
        });
      });
    });
  }

  // ────────────────────────────────────────────────────
  // 4. Parcelamento dinâmico — 3x sem juros
  // ────────────────────────────────────────────────────
  function parsePrice(str) {
    if (!str) return 0;
    return parseFloat(
      String(str).replace(/[^\d,.-]/g, '').replace('.', '').replace(',', '.')
    ) || 0;
  }

  function formatBRL(n) {
    return n.toLocaleString('pt-BR', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  }

  function updateInstallments(priceStr, target) {
    var price = parsePrice(priceStr);
    var max = parseInt(target.dataset.florssMaxInstallments || '3', 10);
    var perInstallment = price / max;
    target.innerHTML = 'ou em até <strong>' + max + '× de R$ ' +
      formatBRL(perInstallment) + '</strong> sem juros';
  }

  function initInstallments() {
    document.querySelectorAll('[data-florss-installment]').forEach(function (el) {
      var priceEl = document.querySelector('[data-florss-price]');
      if (priceEl) updateInstallments(priceEl.textContent, el);
    });
  }

  // ────────────────────────────────────────────────────
  // 5. Calculadora de Frete — integração Correios
  //    Endpoint configurável (App Proxy do Shopify)
  //    Esperado retornar JSON: { services: [{ code, name, price, delivery_days }] }
  // ────────────────────────────────────────────────────
  function initShippingCalc() {
    document.querySelectorAll('[data-florss-shipping-calc]').forEach(function (form) {
      var input = form.querySelector('[data-florss-cep]');
      var button = form.querySelector('[data-florss-calc-btn]');
      var results = form.querySelector('[data-florss-shipping-results]');
      var endpoint = form.dataset.endpoint || '/apps/florss-frete';

      if (!input || !button || !results) return;

      // Máscara de CEP
      input.addEventListener('input', function (e) {
        var v = e.target.value.replace(/\D/g, '').slice(0, 8);
        if (v.length > 5) v = v.slice(0, 5) + '-' + v.slice(5);
        e.target.value = v;
      });

      function calculate() {
        var cep = input.value.replace(/\D/g, '');
        if (cep.length !== 8) {
          results.innerHTML = '<p class="florss-shipping__error">Digite um CEP válido.</p>';
          return;
        }

        results.innerHTML = '<p class="florss-shipping__loading">Calculando frete...</p>';
        button.disabled = true;

        var productId = form.dataset.productId || '';
        var url = endpoint + '?cep=' + cep + '&product_id=' + productId;

        fetch(url, { headers: { 'Accept': 'application/json' } })
          .then(function (r) {
            if (!r.ok) throw new Error('Falha ao calcular');
            return r.json();
          })
          .then(function (data) {
            renderShippingResults(data, results);
          })
          .catch(function () {
            // Fallback de demonstração quando o endpoint não está configurado
            // Em produção, remova esta parte e mostre erro real
            renderShippingResults({
              services: [
                { code: 'PAC', name: 'PAC', price: 'R$ 18,90', delivery_days: '5 a 7 dias úteis' },
                { code: 'SEDEX', name: 'SEDEX', price: 'R$ 32,40', delivery_days: '2 a 3 dias úteis' }
              ],
              demo: true
            }, results);
          })
          .finally(function () {
            button.disabled = false;
          });
      }

      function renderShippingResults(data, container) {
        if (!data.services || !data.services.length) {
          container.innerHTML = '<p class="florss-shipping__error">Não foi possível calcular para este CEP.</p>';
          return;
        }
        var html = data.services.map(function (s) {
          return '<div class="florss-shipping__row">' +
            '<span class="florss-shipping__name">' + s.name + '</span>' +
            '<span class="florss-shipping__days">' + s.delivery_days + '</span>' +
            '<span class="florss-shipping__price">' + s.price + '</span>' +
            '</div>';
        }).join('');
        container.innerHTML = html;
      }

      button.addEventListener('click', calculate);
      input.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          calculate();
        }
      });
    });
  }

  // ────────────────────────────────────────────────────
  // 6. Galeria — clique em thumb troca imagem principal
  // ────────────────────────────────────────────────────
  function initGallery() {
    document.querySelectorAll('[data-florss-gallery]').forEach(function (gal) {
      var thumbs = gal.querySelectorAll('[data-florss-thumb]');
      var main = gal.querySelector('[data-florss-main-image]');
      if (!main) return;

      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          var src = thumb.dataset.florssSrc;
          var alt = thumb.dataset.florssAlt || '';
          if (!src) return;
          main.src = src;
          main.alt = alt;
          thumbs.forEach(function (t) { t.classList.remove('is-active'); });
          thumb.classList.add('is-active');
        });
      });
    });
  }

  // ────────────────────────────────────────────────────
  // 7. Aviso de estoque baixo (visual apenas, não consulta API)
  // ────────────────────────────────────────────────────
  function initStockWarning() {
    document.querySelectorAll('[data-florss-stock-warning]').forEach(function (el) {
      var threshold = parseInt(el.dataset.threshold || '10', 10);
      var available = parseInt(el.dataset.available || '0', 10);
      if (available > 0 && available <= threshold) {
        el.style.display = '';
        el.querySelector('[data-florss-stock-count]').textContent = available;
      } else {
        el.style.display = 'none';
      }
    });
  }

  // ────────────────────────────────────────────────────
  // 8. Timer de urgência (configurável via setting)
  // ────────────────────────────────────────────────────
  function initUrgencyTimer() {
    document.querySelectorAll('[data-florss-timer]').forEach(function (el) {
      var hours = parseInt(el.dataset.hours || '2', 10);
      var minutes = parseInt(el.dataset.minutes || '14', 10);
      var seconds = parseInt(el.dataset.seconds || '33', 10);
      var total = hours * 3600 + minutes * 60 + seconds;
      var display = el.querySelector('[data-florss-timer-display]');
      if (!display) return;

      function tick() {
        var h = Math.floor(total / 3600);
        var m = Math.floor((total % 3600) / 60);
        var s = total % 60;
        display.textContent =
          String(h).padStart(2, '0') + ':' +
          String(m).padStart(2, '0') + ':' +
          String(s).padStart(2, '0');
        if (total > 0) total -= 1;
      }
      tick();
      setInterval(tick, 1000);
    });
  }

  // ────────────────────────────────────────────────────
  // Init geral
  // ────────────────────────────────────────────────────
  function init() {
    initStickyATC();
    initQuantityStepper();
    initVariantPicker();
    initInstallments();
    initShippingCalc();
    initGallery();
    initStockWarning();
    initUrgencyTimer();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* FLORSS_QTY_TOTAL_PATCH_START */
(function () {
  'use strict';

  if (window.__florssQtyTotalPatchLoaded) return;
  window.__florssQtyTotalPatchLoaded = true;

  function parseBRL(text) {
    if (!text) return 0;

    var cleaned = String(text)
      .replace(/[^\d,.-]/g, '')
      .replace(/\./g, '')
      .replace(',', '.');

    return Math.round((parseFloat(cleaned) || 0) * 100);
  }

  function formatBRL(cents) {
    return (cents / 100).toLocaleString('pt-BR', {
      style: 'currency',
      currency: 'BRL',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  }

  function getQty() {
    var input = document.querySelector('[data-florss-qty] input[name="quantity"]');
    var qty = input ? parseInt(input.value, 10) : 1;

    if (!qty || qty < 1) qty = 1;
    if (input && String(input.value) !== String(qty)) input.value = qty;

    return qty;
  }

  function getPriceElement() {
    return document.querySelector('[data-florss-price]');
  }

  function getCompareElement() {
    return document.querySelector('[data-florss-compare-price]');
  }

  function getSavingElement() {
    return document.querySelector('.florss-buybox__price .florss-badge--sage');
  }

  function getInstallmentElement() {
    return document.querySelector('[data-florss-installment]');
  }

  function cacheInitialUnitPrices() {
    var priceEl = getPriceElement();
    var compareEl = getCompareElement();

    if (priceEl && !priceEl.dataset.florssUnitCents) {
      priceEl.dataset.florssUnitCents = String(parseBRL(priceEl.textContent));
    }

    if (compareEl && !compareEl.dataset.florssUnitCents) {
      compareEl.dataset.florssUnitCents = String(parseBRL(compareEl.textContent));
    }
  }

  function updateTotalPrice() {
    cacheInitialUnitPrices();

    var qty = getQty();
    var priceEl = getPriceElement();
    var compareEl = getCompareElement();
    var savingEl = getSavingElement();
    var installmentEl = getInstallmentElement();
    var stickyPriceEl = document.querySelector('.sticky-price');

    if (!priceEl) return;

    var unitCents = parseInt(priceEl.dataset.florssUnitCents || '0', 10);
    var compareUnitCents = compareEl ? parseInt(compareEl.dataset.florssUnitCents || '0', 10) : 0;

    if (!unitCents) return;

    var totalCents = unitCents * qty;

    priceEl.textContent = formatBRL(totalCents);

    if (compareEl) {
      if (compareUnitCents > unitCents) {
        compareEl.textContent = formatBRL(compareUnitCents * qty);
        compareEl.style.display = '';

        if (savingEl) {
          savingEl.textContent = 'Economize ' + formatBRL((compareUnitCents - unitCents) * qty);
          savingEl.style.display = 'inline-flex';
        }
      } else {
        compareEl.style.display = 'none';
        if (savingEl) savingEl.style.display = 'none';
      }
    }

    if (installmentEl) {
      var maxInstallments = parseInt(installmentEl.dataset.florssMaxInstallments || '3', 10) || 3;
      var installmentCents = Math.round(totalCents / maxInstallments);

      installmentEl.innerHTML =
        'ou em até <strong>' +
        maxInstallments +
        '× de ' +
        formatBRL(installmentCents) +
        '</strong> sem juros';
    }

    if (stickyPriceEl) {
      var stickyMax = installmentEl ? parseInt(installmentEl.dataset.florssMaxInstallments || '3', 10) || 3 : 3;
      stickyPriceEl.textContent =
        formatBRL(totalCents) +
        ' · ' +
        stickyMax +
        '× ' +
        formatBRL(Math.round(totalCents / stickyMax));
    }
  }

  function bindQuantityEvents() {
    document.querySelectorAll('[data-florss-qty]').forEach(function (wrap) {
      var input = wrap.querySelector('input[name="quantity"]');
      var minus = wrap.querySelector('[data-florss-qty-dec]');
      var plus = wrap.querySelector('[data-florss-qty-inc]');

      if (input) {
        input.addEventListener('input', updateTotalPrice);
        input.addEventListener('change', updateTotalPrice);
      }

      if (minus) minus.addEventListener('click', function () {
        setTimeout(updateTotalPrice, 0);
      });

      if (plus) plus.addEventListener('click', function () {
        setTimeout(updateTotalPrice, 0);
      });
    });
  }

  function bindVariantEvents() {
    document.querySelectorAll('[data-florss-variant]').forEach(function (button) {
      button.addEventListener('click', function () {
        setTimeout(function () {
          var priceEl = getPriceElement();
          var compareEl = getCompareElement();

          if (priceEl && button.dataset.florssPrice) {
            priceEl.dataset.florssUnitCents = String(parseBRL(button.dataset.florssPrice));
          }

          if (compareEl) {
            if (button.dataset.florssCompare) {
              compareEl.dataset.florssUnitCents = String(parseBRL(button.dataset.florssCompare));
            } else {
              compareEl.dataset.florssUnitCents = '0';
            }
          }

          updateTotalPrice();
        }, 0);
      });
    });
  }

  function initQtyTotalPatch() {
    cacheInitialUnitPrices();
    bindQuantityEvents();
    bindVariantEvents();
    updateTotalPrice();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initQtyTotalPatch);
  } else {
    initQtyTotalPatch();
  }
})();
/* FLORSS_QTY_TOTAL_PATCH_END */

/* FLORSS_BUY_NOW_FREE_SHIPPING_PATCH_START */
(function () {
  'use strict';

  if (window.__florssBuyNowFreeShippingPatchLoaded) return;
  window.__florssBuyNowFreeShippingPatchLoaded = true;

  var THRESHOLD_CENTS = 29900;

  function getQty(form) {
    var input = form.querySelector('input[name="quantity"]');
    var qty = input ? parseInt(input.value, 10) : 1;
    return qty && qty > 0 ? qty : 1;
  }

  function getVariantId(form) {
    var input = form.querySelector('input[name="id"]');
    return input ? input.value : null;
  }

  function addToCart(variantId, quantity) {
    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        id: Number(variantId),
        quantity: quantity
      })
    }).then(function (res) {
      if (!res.ok) throw new Error('Erro ao adicionar ao carrinho');
      return res.json();
    });
  }

  function getCart() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (res) { return res.json(); });
  }

  function bindBuyNow() {
    document.addEventListener('click', function (event) {
      var button = event.target.closest('[data-florss-buy-now]');
      if (!button) return;

      var form = button.closest('form');
      if (!form) return;

      event.preventDefault();

      var variantId = getVariantId(form);
      var quantity = getQty(form);

      if (!variantId) {
        window.location.href = '/cart';
        return;
      }

      button.setAttribute('disabled', 'disabled');
      button.classList.add('is-loading');

      addToCart(variantId, quantity)
        .then(getCart)
        .then(function (cart) {
          if ((cart.total_price || 0) >= THRESHOLD_CENTS) {
            window.location.href = '/checkout';
          } else {
            window.location.href = '/cart?frete-gratis=1';
          }
        })
        .catch(function () {
          window.location.href = '/cart';
        });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindBuyNow);
  } else {
    bindBuyNow();
  }
})();
/* FLORSS_BUY_NOW_FREE_SHIPPING_PATCH_END */

/* FLORSS_ADD_TO_CART_TRACKING_START */
(function () {
  if (window.__florssAddToCartTrackingLoaded) return;
  window.__florssAddToCartTrackingLoaded = true;

  function send(payload) {
    fetch('https://n8n.florss.com.br/webhook/florss/flora-click', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
      keepalive: true
    }).catch(function () {});
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('button, a');
    if (!button) return;

    var text = (button.innerText || button.textContent || '').toLowerCase();
    var isBuyButton =
      text.includes('adicionar ao carrinho') ||
      text.includes('quero meu kit') ||
      text.includes('comprar agora');

    if (!isBuyButton) return;

    var payload = {
      event: 'add_to_cart',
      event_name: 'add_to_cart',
      product_title: document.title || '',
      product_handle: window.location.pathname.replace('/products/', ''),
      page_url: window.location.href,
      timestamp: new Date().toISOString()
    };

    console.log('florss_add_to_cart', payload);
    send(payload);
  });
})();
/* FLORSS_ADD_TO_CART_TRACKING_END */
